//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import TimeZoneId from '@models/TimeZoneId';

/**
 * Returns the localized name for the given timezone in the given length.
 * * @examples
 * - getTimezoneName('America/New_York, 'long') --> 'Eastern Standard Time' | 'Eastern Daylight Time'
 * - getTimezoneName('America/New_York, 'short') --> 'EST' | 'EDT'
 */
export const getTimezoneName = (
  timeZone: TimeZoneId,
  length: 'short' | 'long',
) => {
  /**
   * Returns a date formatted as "DATE, TIME ZONE", so we extract the timeZone by splitting
   * at the comma and stripping out the extra leading space.
   */
  const formattedDate = Intl.DateTimeFormat(
    // Curalate only supports the en-US locale
    'en-US',
    { timeZone, timeZoneName: length },
  ).format(new Date());

  const timeZoneName = formattedDate.split(',')[1]?.trim() ?? '';
  return timeZoneName;
};

/**
 * Returns the localized names (in both long and short form) for the given timezone.
 */
export const getTimezoneNames = (timeZone: TimeZoneId) => {
  const long = getTimezoneName(timeZone, 'long');
  const short = getTimezoneName(timeZone, 'short');
  return { long, short };
};
